<template>
  <div>
    <div v-if="loading.isVisible && loading.status == 'loading'" class="LoadingBar"></div>
    <div class="LoadingBox" :class="loadingBoxClasses">
      <icon :name="icon" size="large" :positive="positive" :negative="!positive" :spin="animation"></icon>
      <span class="LoadingBox__content">{{ loading.message }}</span>
      <span class="LoadingBox__close" @click="closeLoadingBox">×</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: Object
  },
  methods: {
    closeLoadingBox() {
      EventBus.$emit('loading-hide');
    }
  },
  computed: {
    loadingBoxClasses() {
      return {
        '-act': this.loading.isVisible
      }
    },
    positive() {
        return this.loading.status != 'failed';
    },
    animation() {
      return this.loading.status === 'loading';
    },
    icon() {
      if (this.loading.status === 'loading') return 'spinner';
      if (this.loading.status === 'success') return 'check-circle';
      if (this.loading.status === 'failed') return 'close-circle';
    }
  }
}
</script>

<style lang="stylus">
    .LoadingBox
        cursor default
        display flex
        justify-content center
        align-items center
        background #fff
        position fixed
        border-radius 3px
        padding 12px
        padding-left 20px
        z-index 100
        bottom 24px
        left 48px
        color #898989
        font-weight 400
        opacity 0
        transform translateY(80px)
        user-select none
        will-change transform
        transition all 0.15s cubic-bezier(.45,.16,.33,.89)
        box-shadow 0 2px 10px -1px rgba(0, 0, 0, 0.3), 
                   0px 0px 3px rgba(0, 0, 0, 0.1) inset
        &.-act
            opacity 1
            transform translateY(0)

    .LoadingBox__close
        font-weight 600
        font-size 1.4em
        color rgba(0, 0, 0, 0.35)
        cursor pointer
        width 32px
        text-align center
        height 32px
        &:hover,
        &:focus
            color rgba(0, 0, 0, 0.45)
        
    .LoadingBox__content
        padding 0 12px
</style>
